import {
  createReactRouterV6DataOptions,
  EventEvent,
  ExceptionEventExtended,
  faro,
  getWebInstrumentations,
  initializeFaro,
  LogLevel,
  ReactIntegration,
  TransportItem,
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { matchRoutes } from 'react-router';

import { config } from '~/config';

const notLocal = config.urls.root !== 'http://localhost:1234';
const stagingOrProd =
  ['staging', 'prod'].includes(config.app.environment) && notLocal;

const initialise = () => {
  if (stagingOrProd) {
    initializeFaro({
      url: config.faro.url,
      app: {
        name: 'terminal',
        version: config.app.version,
        environment: config.app.environment,
      },
      batching: {
        itemLimit: 150,
        sendTimeout: 1000,
      },
      instrumentations: [
        ...getWebInstrumentations(),
        new TracingInstrumentation(),
        new ReactIntegration({
          router: createReactRouterV6DataOptions({
            matchRoutes,
          }),
        }),
      ],
      preserveOriginalError: true,
      beforeSend: item => {
        if (item.type === 'exception') {
          const _item = item as TransportItem<ExceptionEventExtended>;
          const originalError = _item.payload.originalError;
          const msg = originalError?.message || '';

          // Ignore AbortError specifically
          if (msg.includes('AbortError')) {
            return null; // prevents sending to backend
          }
        }

        if (item.type === 'event') {
          const itemPayload = item.payload as EventEvent;
          const attributeName = itemPayload?.attributes?.name;

          if (
            attributeName &&
            (attributeName.includes(config.posthog.apiHost) ||
              attributeName.includes(config.posthog.uiHost))
          ) {
            return null;
          }
        }

        return item;
      },
    });
  }
};

const captureException = (
  exception: Error | unknown,
  context?: Record<string, string>
) => {
  stagingOrProd
    ? faro.api.pushError(exception as Error, {
        context,
      })
    : // eslint-disable-next-line no-console
      console.error({
        Logger: exception,
        context,
      });
};

const captureMessage = (message: string, level?: LogLevel) =>
  stagingOrProd
    ? faro.api.pushLog([message], {
        level: level ?? LogLevel.INFO,
      }) // eslint-disable-next-line no-console
    : console.error({ Logger: message });

export const initialiseUser = (id: string) => {
  if (stagingOrProd) {
    faro.api.setUser({
      id,
    });
  }
};

export const Tracking = {
  initialise,
  captureException,
  captureMessage,
  initialiseUser,
};
